import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { Button, Logo } from '@morressier/alembic';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import EmptyState from 'src/components/Submission/BoardMemberReviewsTab/EmptyState';
import { useAuthRealm } from 'src/routes/AuthRealmAccessControl/AuthRealmContext';

export const BrandLogo = () => {
  const { clientBrand } = useAuthRealm();

  return (
    <Flex my={2}>
      <Logo
        src={clientBrand.logoUrl}
        alt={`${clientBrand.name} logo`}
        maxWidth="200px"
        maxH="40px"
        minH="40px"
      />
    </Flex>
  );
};

const SignUpInviteSent = () => {
  const { email } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  return (
    <Flex flexDirection="column" gap={3} width={{ base: '95%', md: '80%' }} marginX={'auto'}>
      <BrandLogo />
      <Flex direction="column">
        <EmptyState
          title=""
          subTitle={
            <Flex
              direction={'column'}
              justifyContent={'flex-start'}
              alignItems={'flex-start'}
              textAlign={'left'}
              gap={6}
            >
              <Box>
                <Text textStyle="headingTitle">Invitation sent</Text>
                <Text wordBreak="break-word">
                  {status === 'draft'
                    ? `An email to resume your sign up has been sent to ${email}. Check your inbox to continue. `
                    : `We have emailed a sign-up invitation to ${email}. Check your inbox to get started.`}
                </Text>
              </Box>
              <Button
                onClick={() => {
                  navigate('/signup');
                }}
              >
                Back to Sign Up
              </Button>
            </Flex>
          }
          bgColor="successSecondaryFill"
          icon={faCircleCheck}
          borderRadius={8}
        />
      </Flex>
    </Flex>
  );
};

export default SignUpInviteSent;
